module.exports = __webpack_public_path__ + "static/media/hr.9e251fca.svg";